import { SecureBuffer } from "./SecureBuffer";

export function SecureBufferW(wsMgr, theBuffer) {
  var org = wsMgr.GetAccountName();
  var user = wsMgr.GetUserName();
  return SecureBuffer(org, user, theBuffer);
}
